import React, { memo } from 'react'
import { makeStyles } from '@material-ui/styles'
import InfiniteScroll from 'react-infinite-scroller'
import classNames from 'classnames'

import { Card, Loading } from 'components'
import styles from '../styles'
import { StoreValue } from 'store'
import { SearchEmptyResult } from '.'
import { useSearchArticlesQuery } from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const Articles: React.FunctionComponent<any> = ({
	storeSearchDebounceQuery,
}) => {
	const classes = useStyles()
	const {
		data: searchArticlesData,
		loading: searchArticlesLoading,
		fetchMore: fetchMoreSearchArticles,
	} = useSearchArticlesQuery({
		variables: {
			first: 10,
			query: '%' + storeSearchDebounceQuery + '%',
		},
		fetchPolicy: 'network-only',
		notifyOnNetworkStatusChange: false,
	})
	// const {
	// 	data: searchArticlesData,
	// 	loading: searchArticlesLoading,
	// 	fetchMore: fetchMoreSearchArticles,
	// } = useQuery(SearchArticlesDocument, {
	// 	variables: {
	// 		offset: 0,
	// 		query: "%" + storeSearchDebounceQuery + "%",
	// 	},
	// 	fetchPolicy: 'network-only',
	// 	notifyOnNetworkStatusChange: false,
	// })

	const articles = searchArticlesData?.articleCollection?.edges
		? searchArticlesData.articleCollection.edges?.map(edge => edge.node)
		: []

	const hasNextPage = searchArticlesData?.articleCollection?.pageInfo
		? searchArticlesData.articleCollection.pageInfo.hasNextPage
		: false

	return (
		<div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
			{!searchArticlesLoading &&
				searchArticlesData?.articleCollection?.edges?.length === 0 && (
					<SearchEmptyResult query={storeSearchDebounceQuery} />
				)}
			<div
				className={classNames(
					classes.tabsContentContainer,
					classes.tabsContentContainerCompany,
					classes.fixFlexList,
				)}
			>
				<InfiniteScroll
					pageStart={0}
					loadMore={() => {
						return fetchMoreSearchArticles({
							variables: {
								query: storeSearchDebounceQuery,
								offset: searchArticlesData?.articleCollection
									?.edges
									? searchArticlesData?.articleCollection
											?.edges.length
									: 0,
							},
							updateQuery: (
								previousQueryResult,
								{ fetchMoreResult },
							) => {
								if (
									!fetchMoreResult ||
									!fetchMoreResult.articleCollection
								) {
									return previousQueryResult
								}

								const { edges: newEdges, pageInfo } =
									fetchMoreResult.articleCollection

								return newEdges.length > 0
									? {
											articleCollection: {
												__typename:
													previousQueryResult
														.articleCollection
														?.__typename,
												edges: [
													...(previousQueryResult
														?.articleCollection
														?.edges || []),
													...newEdges,
												],
												pageInfo,
											},
									  }
									: previousQueryResult
							},
						})
					}}
					hasMore={hasNextPage}
					loader={
						<div
							style={{ flexGrow: 1, display: 'flex' }}
							key={'loading'}
						>
							<Loading
								size={48}
								style={{ margin: '50px auto' }}
							/>
						</div>
					}
					className={classes.searchContentCards}
				>
					{articles &&
						articles?.map((item: any, index: number) => (
							<Card
								key={item.id}
								article={item}
								extraClassesContainer={
									classes.articlesContainer
								}
							/>
						))}
				</InfiniteScroll>
			</div>
		</div>
	)
}

export default memo((props: any) => (
	<StoreValue
		keys={[
			'storeDispatch',
			'search.debounceQuery|storeSearchDebounceQuery',
			'search.loading|storeSearchLoading',
		]}
	>
		<Articles {...props} />
	</StoreValue>
))
